angular
  .module 'filters'
  .filter 'parseFloat', ->
    (data) ->
      parseFloat data
